module.exports = __webpack_public_path__ + "static/media/social5.2f5c0c24.png";